import { localisedValue } from "utils"

const agencyClientsTransformer = response => {
  let availableUsers = []

  const transformedData = response?.data?.slice(0, 5)?.map(item => ({
    ...item,
    InternalInquiries: item?.InternalInquiries?.map(inquiry => ({
      ...inquiry,
      InternalInquirySharing: inquiry?.InternalInquirySharing?.map(sharing => {
        const transformedSharing = {
          ...sharing,
          value: sharing?.shareWith,
          label: localisedValue({ object: sharing?.shareWithUser, key: "name" }),
        }
        if (sharing?.shareWithUser?.SalesEventUsers?.[0]?.status === "available") {
          availableUsers.push(transformedSharing)
        }
        return transformedSharing
      }),
    })),
  }))
  return {
    ...response,
    data: transformedData,
    availableUsers,
  }
}

export default agencyClientsTransformer
